module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5n4r8r7r-05067e70be09b91d3b5e9512b5c6878d.svg";